<div
  class="chat-root"
  [class.component-loading]="!componentReady"
  cdkDrag
  cdkDragBoundary="body"
  cdkDragRootElement=".cdk-overlay-pane">
  <!-- Header -->
  <div
    class="header-bar"
    cdkDragHandle>
    @if (allowAIChatSettings) {
      <button
        mat-icon-button
        class="header-gear"
        [matMenuTriggerFor]="rootMenu"
        aria-label="Open settings"
        (mousedown)="$event.stopPropagation()">
        <fa-icon icon="gear"></fa-icon>
      </button>
    }

    <h3 class="header-title">
      <fa-icon icon="sparkles" class="header-title-icon"></fa-icon>
      <span>KI-Chat</span>
    </h3>

    <button
      mat-icon-button
      class="header-close"
      aria-label="Close chat"
      (click)="closeChat()"
      (mousedown)="$event.stopPropagation()">
      <fa-icon icon="xmark"></fa-icon>
    </button>
  </div>

  <mat-divider></mat-divider>

  <mat-menu
    #rootMenu="matMenu"
    panelClass="gear-panel">
    <button
      mat-menu-item
      [matMenuTriggerFor]="settingsMenu">
      Settings
    </button>
    <button
      mat-menu-item
      [matMenuTriggerFor]="aiMenu">
      AI Engines
    </button>
  </mat-menu>

  <mat-menu
    #settingsMenu="matMenu"
    panelClass="gear-panel">
    <button
      mat-menu-item
      (click)="onToggleDebug($event)">
      <mat-checkbox
        [(ngModel)]="debugMode"
        (click)="$event.stopPropagation()"
        >Debug Mode</mat-checkbox
        >
      </button>
      <button
        mat-menu-item
        (click)="onToggleOverwrite($event)">
        <mat-checkbox
          [(ngModel)]="ovewriteMode"
          (click)="$event.stopPropagation()"
          >Überschreib Mode</mat-checkbox
          >
        </button>
        <button
          mat-menu-item
          (click)="onToggleAnonymize($event)">
          <mat-checkbox
            [(ngModel)]="anonymizeMode"
            (click)="$event.stopPropagation()"
            >Anonymisierung</mat-checkbox
            >
          </button>
        </mat-menu>

        <mat-menu
          #aiMenu="matMenu"
          panelClass="gear-panel">
          <button
            mat-menu-item
            [matMenuTriggerFor]="chatgpt5Menu"
            (click)="selectSystem('chatgpt5')">
            ChatGPT 5
          </button>
          <button
            mat-menu-item
            [matMenuTriggerFor]="chatgptMenu"
            (click)="selectSystem('chatgpt')">
            ChatGPT
          </button>
          <button
            mat-menu-item
            [matMenuTriggerFor]="localMenu"
            (click)="selectSystem('local')">
            Local LLM
          </button>
        </mat-menu>

        <mat-menu
          #chatgpt5Menu="matMenu"
          panelClass="gear-panel">
          <button
            mat-menu-item
            (click)="selectModel('gpt-5')">
            gpt-5
          </button>
          <button
            mat-menu-item
            (click)="selectModel('gpt-5-mini')">
            gpt-5-mini
          </button>
          <button
            mat-menu-item
            (click)="selectModel('gpt-5-nano')">
            gpt-5-nano
          </button>
        </mat-menu>

        <mat-menu
          #chatgptMenu="matMenu"
          panelClass="gear-panel">
          <button
            mat-menu-item
            (click)="selectModel('gpt-4o')">
            gpt-4o
          </button>
          <button
            mat-menu-item
            (click)="selectModel('gpt-4')">
            gpt-4
          </button>
          <button
            mat-menu-item
            (click)="selectModel('gpt-3.5-turbo')">
            gpt-3.5-turbo
          </button>
        </mat-menu>

        <mat-menu
          #localMenu="matMenu"
          panelClass="gear-panel">
          <button
            mat-menu-item
            (click)="selectModel('tinyllama:latest')">
            tinyllama:latest
          </button>
          <button
            mat-menu-item
            (click)="selectModel('deepseek-r1:8b')">
            deepseek-r1:8b
          </button>
          <button
            mat-menu-item
            (click)="selectModel('deepseek-r1:1.5b')">
            deepseek-r1:1.5b
          </button>
        </mat-menu>

        <div
          class="content-container"
          [ngClass]="{'content-centered': !chatStarted}">
          <div class="chat-body">
            @if (chatStarted) {
              <div
                class="chat-scroll"
                #scrollContainer>
                @for (message of messages; track message) {
                  <div
                    class="message"
                    >
                    @if (message.icon && message.icon !== 'robot') {
                      <fa-icon
                        [icon]="$any(message.icon)"
                        class="message-icon"
                        [ngClass]="{'fa-spin': message.icon === 'spinner', 'response-icon': !message.isUser}">
                      </fa-icon>
                    }
                    @if (!message.isUser && (!message.icon || message.icon === 'robot')) {
                      <img
                        src="assets/img/logos/logo_pharmakon_icon_orange_200px.svg"
                        alt="AI"
                        class="message-icon ai-logo" />
                    }
                    @if ((!message.icon && message.isUser)) {
                      <div
                        class="message-icon empty-icon">
                      </div>
                    }
                    <!-- AI message -->
                    @if (!message.isUser) {
                      <div
                        class="message-col"
                        >
                        <div class="message-meta ai">
                          <span class="message-name">Pharmakon Chat</span>
                          <time
                            class="message-time"
                            [attr.datetime]="message.ts | date: 'yyyy-MM-ddTHH:mm:ss'">
                            {{ message.ts | date: 'HH:mm' }}
                          </time>
                        </div>
                        <div class="other-message">
                          <markdown
                            class="message-text md"
                          [data]="mdWithBr(message.text)"></markdown>
                        </div>
                      </div>
                    }
                    <!-- User message -->
                    @if (message.isUser) {
                      <div
                        class="message-col align-right"
                        >
                        <time
                          class="message-time"
                          [attr.datetime]="message.ts | date: 'yyyy-MM-ddTHH:mm:ss'">
                          {{ message.ts | date: 'HH:mm' }}
                        </time>
                        <div class="user-message">
                          <markdown
                            class="message-text md"
                            [data]="mdWithBr(message.text)">
                          </markdown>
                        </div>
                      </div>
                    }
                  </div>
                }
                <div id="scrollToMessage"></div>
              </div>
            }

            <!-- suggestions -->
            @if (!chatStarted) {
              <div
                class="suggestions-wrap">
                <h2 class="suggestions-title">VORSCHLÄGE</h2>
                @if (suggestions?.length) {
                  @for (suggestion of suggestions; track trackSuggestion($index, suggestion)) {
                    <mat-card
                      class="suggestion"
                      (click)="send(suggestion.prompt, suggestion.label)">
                      <span>{{ suggestion.label }}</span>
                    </mat-card>
                  }
                } @else {
                  <mat-card class="suggestion" aria-hidden="true"><span>Keine Vorschläge verfügbar</span></mat-card>
                }
              </div>
            }
          </div>
        </div>

        <!-- Footer / input -->
        <div class="chat-input input-container">
          <div class="input-wrapper" [class.input-focused]="inputFocused">
            <textarea
              class="preset input-textarea"
              #input
              (input)="autoResize(input)"
              (keydown.enter)="onEnter($any($event), input)"
              (focus)="onInputFocus()"
              (blur)="onInputBlur()"
              placeholder="Etwas fragen"
            [rows]="1"></textarea>

            <button
              type="button"
              class="pro-analyze-toggle"
              [class.is-active]="proAnalyzeEnabled"
              [attr.aria-pressed]="proAnalyzeEnabled"
              matTooltip="Wenn aktiviert, denkt es länger nach und antwortet schlauer – dadurch dauert die Anfrage etwas länger."
              (click)="toggleProAnalyze()">
              <fa-icon icon="brain"></fa-icon>
              <span>Pro Analyse</span>
            </button>

            <button
              #button
              class="button-send"
              mat-icon-button
              medium-icon-button
              [attr.aria-label]="responseInProgress ? 'Antwort stoppen' : 'Nachricht senden'"
              (click)="onSendButtonClick()">
              <fa-icon
                class="icon-button"
              [icon]="responseInProgress ? 'stop' : 'paper-plane-top'"></fa-icon>
            </button>
          </div>
        </div>
      </div>
